import React, { useEffect } from "react";
import { Container, Typography, Box, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const C = {
  darkBlue: "#0C1F2F",
  navy: "#0057A8",
  gold: "#FFCD00",
  gray: "#F5F7FA",
  softGold: "#c2ed80",
};

export default function TerminosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const terminos = [
    {
      title: "Naturaleza del servicio",
      text: "El sitio web de ELÉCTRICA GRM es una plataforma informativa y de contacto orientada a facilitar la comercialización y cotización de material eléctrico, herramientas e iluminación.",
    },
    {
      title: "Cotizaciones y Precios",
      text: "Los precios y disponibilidad de los productos están sujetos a confirmación por parte de nuestro equipo de ventas a través de nuestros canales oficiales (WhatsApp, Email o llamadas).",
    },
    {
      title: "Envíos y Entregas",
      text: "Realizamos envíos a nivel nacional y despachos directos en la ciudad de Quito. Los tiempos de entrega pueden variar dependiendo del volumen del pedido y la ubicación de destino.",
    },
    {
      title: "Garantía de Productos",
      text: "Todos nuestros productos cuentan con garantía directa de fábrica. Las condiciones de la garantía varían según la marca y el tipo de material eléctrico adquirido.",
    },
    {
      title: "Uso adecuado del sitio web",
      text: "El usuario se compromete a utilizar la información y catálogos proporcionados en este sitio web únicamente con fines de consulta comercial.",
    },
    {
      title: "Propiedad Intelectual",
      text: "Todas las marcas, logotipos y catálogos mostrados en este sitio web son propiedad de sus respectivos fabricantes y se utilizan exclusivamente con fines de distribución autorizada.",
    },
    {
      title: "Contacto Legal",
      text: "Para consultas relacionadas con estos términos comerciales o políticas de distribución, puede comunicarse a gerencia@electricagrm.com.",
    },
  ];

  return (
    <Box
      sx={{
        background: C.gray,
        minHeight: "100vh",
        // Aumentamos el padding top para que el navbar no tape el contenido en ninguna pantalla
        pt: { xs: "120px", md: "140px" },
        pb: { xs: 8, md: 10 },
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: C.darkBlue,
            mb: 2,
            fontSize: { xs: "2rem", md: "2.8rem" },
          }}
        >
          Términos y Condiciones
        </Typography>
        <Typography
          sx={{ color: "#5c6c7a", mb: 6, fontSize: "1.1rem", lineHeight: 1.6 }}
        >
          El uso del sitio web de ELÉCTRICA GRM implica la aceptación de los
          presentes términos y condiciones relacionados con la consulta y
          cotización de nuestros productos.
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            background: "#fff",
            p: { xs: 3, md: 5 },
            borderRadius: "20px",
            boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
          }}
        >
          {terminos.map((item, index) => (
            <Box key={index}>
              <Typography
                variant="h6"
                sx={{
                  color: C.navy,
                  fontWeight: 750,
                  mb: 1,
                  fontSize: "1.15rem",
                }}
              >
                {index + 1}. {item.title}
              </Typography>
              <Typography
                sx={{ color: "#4e5f6e", lineHeight: 1.7, fontSize: "1rem" }}
              >
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Botón movido a la parte inferior y centrado */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 6 }}>
          <Button
            onClick={() => window.close()}
            startIcon={<ArrowBackIcon />}
            sx={{
              color: C.white,
              background: C.gold,
              fontWeight: 700,
              textTransform: "none",
              fontSize: "1rem",
              px: 4,
              py: 1.5,
              borderRadius: "50px",

              transition: "all 0.3s ease",
              "&:hover": {
                background: C.softGold,
                transform: "translateY(-3px)",
              },
            }}
          >
            Cerrar esta pestaña
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
